/**
 * @file LogoutCallback.jsx
 * @description Callback view displayed during the secure logout and cleanup process.
 * @module components/LogoutCallback
 */
import React, { useEffect } from 'react';
import { FiLoader } from 'react-icons/fi';

/* ══════════════════════════════════════════════════════════════
 * MAIN COMPONENT
 * ══════════════════════════════════════════════════════════════ */

/**
 * @component LogoutCallback
 * @description Renders a secure, branded loading state while the user session
 *              is being securely terminated by the AuthContext and Supabase.
 *
 * @returns {JSX.Element} The rendered Logout Callback loader.
 */

const LogoutCallback = () => {
    // ── Component State ──
    
    useEffect(() => {
        document.title = "SimpleCode | Signing Out...";
        return () => {
            document.title = "SimpleCode";
        };
    }, []);
    return (
        <div className="min-h-screen bg-emerald-800 flex flex-col items-center justify-center font-sans p-4">
            {/* Logo area */}
            <div className="mb-10 animate-in fade-in slide-in-from-top-4 duration-1000">
                <img
                    src="/logo.png"
                    alt="SimpleCode"
                    className="h-10 sm:h-12 w-auto"
                />
            </div>

            <div className="flex flex-col items-center space-y-6 animate-in fade-in zoom-in-95 duration-700">
                <FiLoader className="text-5xl text-white animate-spin" />
                
                <div className="text-center space-y-2">
                    <h2 className="text-2xl font-medium text-white tracking-wide">
                        Signing out...
                    </h2>
                    <p className="text-emerald-100/80 text-sm max-w-sm px-2">
                        Please wait while we securely log you out.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LogoutCallback;
